import { render, staticRenderFns } from "./ListaProcedimentos.vue?vue&type=template&id=b5733372&scoped=true&"
import script from "./ListaProcedimentos.vue?vue&type=script&lang=js&"
export * from "./ListaProcedimentos.vue?vue&type=script&lang=js&"
import style0 from "./ListaProcedimentos.vue?vue&type=style&index=0&id=b5733372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5733372",
  null
  
)

export default component.exports